













import { Component, Vue, Prop } from 'vue-property-decorator';
import t from '@/i18n/translations'
import { Getter } from 'vuex-class';

const namespace = 'progress';

@Component({ })
export default class ProgressHeader extends Vue {
    @Prop({ }) data: any;
    @Getter('getProgressStatus', { namespace }) getProgressStatus: any;

    @Getter('getIsStep1Filled', { namespace }) getIsStep1Filled: any;
    @Getter('getIsStep2Filled', { namespace }) getIsStep2Filled: any;
    @Getter('getIsStep3Filled', { namespace }) getIsStep3Filled: any;

    @Getter('getIsStep1Active', { namespace }) getIsStep1Active: any;
    @Getter('getIsStep2Active', { namespace }) getIsStep2Active: any;
    @Getter('getIsStep3Active', { namespace }) getIsStep3Active: any;

    @Getter('getIsVisible', { namespace }) getIsVisible: any;

    i18n = t['nl'];
    selectedBranchID: string = '';

    mounted(): void {
    }

    updated(): void {
        this.selectedBranchID = this.$route.params.id;
    }

    onClick(step) {
        switch (step) {
            case 1:
                if (this.getIsStep1Active)
                    this.$router.push({path: `/report/general/${this.selectedBranchID}`});
                break;
            case 2:
                if (this.getIsStep2Active)
                    this.$router.push({path: `/report/form/${this.selectedBranchID}`});
                break;
            case 3:
                if (this.getIsStep3Active)
                    this.$router.push({path: `/report/summary/${this.selectedBranchID}`});
                break;
        }
    }
}
